import Box from 'core-system/Box/Box'
import Chip from 'core-system/Chip'
import SecondaryButton from 'core-system/Button/SecondaryButton'
import FlexContainer from 'core-system/FlexContainer'
import Text from 'core-system/Text'
import palette from 'core-system/Themes/palette'
import React, { useMemo } from 'react'
import { MyCommuterDetails } from 'redux/employee/employeeTypes'
import styled from 'styled-components'

const TagContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`

interface MyCommuterDetailsTagsProps {
  commuterDetails: MyCommuterDetails
  onManageTags: () => void
}

const MyCommuterDetailsTags = React.memo((props: MyCommuterDetailsTagsProps) => {
  const { commuterDetails, onManageTags } = props

  const tagNames = useMemo(() => {
    const names = commuterDetails.tagNames ?? []
    return [...names].sort((a, b) => a.localeCompare(b))
  }, [commuterDetails.tagNames])

  return (
    <Box style={{ padding: '1rem' }}>
      <FlexContainer
        justifyContent='space-between'
        alignItems='center'
        marginBottom='1rem'
      >
        <Text variant='action2'>Tags</Text>
        <SecondaryButton onClick={onManageTags}>Manage Tags</SecondaryButton>
      </FlexContainer>
      {tagNames.length === 0 ? (
        <Text variant='action3' textColor={palette.text.secondary}>
          No tags assigned to this commuter.
        </Text>
      ) : (
        <TagContainer>
          {tagNames.map((name) => (
            <Chip
              variant='filter'
              key={name}
              margin='0 0.5rem 0.5rem 0'
              isInteractive={false}
            >
              {name}
            </Chip>
          ))}
        </TagContainer>
      )}
    </Box>
  )
})

if (process.env.NODE_ENV !== 'production') {
  MyCommuterDetailsTags.displayName = 'MyCommuterDetailsTags'
}

export default MyCommuterDetailsTags
